import Script from "next/script";
import React from "react";

export interface MobiusSnippetProps {
  apiKey?: string;
  domain?: string;
  program?: string;
}

export const MobiusSnippet: React.FC<MobiusSnippetProps> = ({ apiKey, domain, program }) => {
  if (!apiKey || !domain || !program) return null;

  const mode = program?.startsWith("thankyou") ? "ty" : "lp";

  return (
    <>
      <Script id="mobius-pixel">
        {`!function (mo,bi,us) {mo._Mobius=us;var z=bi.createElement('script');z.async=1;
          z.src='https://cdn.mobius.highereducation.com/mobius-latest.min.js';
          bi.head.appendChild(z);
        }(window, document, {
          'endpoint': 'https://api.mobius.highereducation.com/v1',
          'apiKey': '${apiKey}',
          'domain': '${domain}',
          'mode': '${mode}'
        })`}
      </Script>
    </>
  );
};
